
import Vue from 'vue'

const locales = {keys(){return []}}
global['____6D88900____'] = true;
delete global['____6D88900____'];
global.__uniConfig = {"easycom":{"^u-(.*)":"@/uni_modules/uview-ui/components/u-$1/u-$1.vue","uni-(.*)":"@/components/u-$1/u-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"},"globalStyle":{"navigationBarTitleText":"Desigual.","navigationStyle":"custom","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8"}};
global.__uniConfig.compilerVersion = '3.97';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__6D88900';
global.__uniConfig.appName = 'fore_ui';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"./"};
global.__uniConfig.publicPath = "./";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/login/login"+'.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-purchase', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/index/purchase"+'.vue')), 'pages-index-purchase'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-kefu', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/index/kefu"+'.vue')), 'pages-index-kefu'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-my', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/my"+'.vue')), 'pages-my-my'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-grabbing', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/index/grabbing"+'.vue')), 'pages-index-grabbing'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-invite', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/invite"+'.vue')), 'pages-my-invite'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-recharge_record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/recharge_record"+'.vue')), 'pages-my-recharge_record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-recharge', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/recharge"+'.vue')), 'pages-my-recharge'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-nextrecharge', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/nextrecharge"+'.vue')), 'pages-my-nextrecharge'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-withdrawal', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/withdrawal"+'.vue')), 'pages-my-withdrawal'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-deposit_admin', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/deposit_admin"+'.vue')), 'pages-my-deposit_admin'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-user', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/user/user"+'.vue')), 'pages-user-user'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-revise_name', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/user/revise_name"+'.vue')), 'pages-user-revise_name'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-bind_trc20', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/user/bind_trc20"+'.vue')), 'pages-user-bind_trc20'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-bind_bank', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/user/bind_bank"+'.vue')), 'pages-user-bind_bank'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-password_manage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/user/password_manage"+'.vue')), 'pages-user-password_manage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-business_password', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/user/business_password"+'.vue')), 'pages-user-business_password'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/user/address"+'.vue')), 'pages-user-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-account_details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/user/account_details"+'.vue')), 'pages-user-account_details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-team_table', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/team_table"+'.vue')), 'pages-my-team_table'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-msg', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/msg"+'.vue')), 'pages-my-msg'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-msg', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/index/msg"+'.vue')), 'pages-index-msg'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-to_be_paid', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/to_be_paid"+'.vue')), 'pages-my-to_be_paid'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-regist', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/login/regist"+'.vue')), 'pages-login-regist'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-member', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/member"+'.vue')), 'pages-my-member'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-my-lang', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/mac/Downloads/pink/pages/my/lang"+'.vue')), 'pages-my-lang'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
  windowTop:0
}
},
{
path: '/pages/index/purchase',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-index-purchase', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-purchase',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/purchase',
  windowTop:0
}
},
{
path: '/pages/index/kefu',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-index-kefu', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-kefu',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/kefu',
  windowTop:0
}
},
{
path: '/pages/my/my',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-my', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-my',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/my',
  windowTop:0
}
},
{
path: '/pages/index/grabbing',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-index-grabbing', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-grabbing',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/grabbing',
  windowTop:0
}
},
{
path: '/pages/my/invite',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-invite', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-invite',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/invite',
  windowTop:0
}
},
{
path: '/pages/my/recharge_record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-recharge_record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-recharge_record',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/recharge_record',
  windowTop:0
}
},
{
path: '/pages/my/recharge',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-recharge', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-recharge',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/recharge',
  windowTop:0
}
},
{
path: '/pages/my/nextrecharge',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-nextrecharge', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-nextrecharge',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/nextrecharge',
  windowTop:0
}
},
{
path: '/pages/my/withdrawal',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-withdrawal', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-withdrawal',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/withdrawal',
  windowTop:0
}
},
{
path: '/pages/my/deposit_admin',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-deposit_admin', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-deposit_admin',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/deposit_admin',
  windowTop:0
}
},
{
path: '/pages/user/user',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-user-user', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-user',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/user',
  windowTop:0
}
},
{
path: '/pages/user/revise_name',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-user-revise_name', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-revise_name',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/revise_name',
  windowTop:0
}
},
{
path: '/pages/user/bind_trc20',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-user-bind_trc20', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-bind_trc20',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/bind_trc20',
  windowTop:0
}
},
{
path: '/pages/user/bind_bank',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-user-bind_bank', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-bind_bank',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/bind_bank',
  windowTop:0
}
},
{
path: '/pages/user/password_manage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-user-password_manage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-password_manage',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/password_manage',
  windowTop:0
}
},
{
path: '/pages/user/business_password',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-user-business_password', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-business_password',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/business_password',
  windowTop:0
}
},
{
path: '/pages/user/address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-user-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-address',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/address',
  windowTop:0
}
},
{
path: '/pages/user/account_details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-user-account_details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-account_details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/account_details',
  windowTop:0
}
},
{
path: '/pages/my/team_table',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-team_table', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-team_table',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/team_table',
  windowTop:0
}
},
{
path: '/pages/my/msg',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-msg', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-msg',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/msg',
  windowTop:0
}
},
{
path: '/pages/index/msg',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-index-msg', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-msg',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/msg',
  windowTop:0
}
},
{
path: '/pages/my/to_be_paid',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-to_be_paid', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-to_be_paid',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/to_be_paid',
  windowTop:0
}
},
{
path: '/pages/login/regist',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-login-regist', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-regist',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/regist',
  windowTop:0
}
},
{
path: '/pages/my/member',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-my-member', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-member',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/member',
  windowTop:0
}
},
{
path: '/pages/my/lang',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-my-lang', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-my-lang',
  isNVue:false,maxWidth:0,
  pagePath:'pages/my/lang',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
